import { useAppDispatch, useAppSelector } from 'redux/hooks'
import PolygonMarker from 'components/PolygonMarker'
import {
  makeSelectParcelles,
  makeSelectStatusDvf,
  makeSelectSelectedParcelleIndex,
} from 'redux/features/dvf/selectors'
import {
  Status,
  scrollParcelleToTop,
  selectParcelle as selectParcelleAction,
} from 'redux/features/dvf/slice'
import geoJsonObjectToCoordinates from 'utils/geoJsonObjectToCoordinates'

const ResultsDVF = (): JSX.Element => {
  const parcelles = useAppSelector(makeSelectParcelles)
  const statusDvf = useAppSelector(makeSelectStatusDvf)
  const selectedParcelleIndex = useAppSelector(makeSelectSelectedParcelleIndex)
  const dispatch = useAppDispatch()

  const selectParcelle = (uid: string) => {
    dispatch(selectParcelleAction(uid))
    dispatch(scrollParcelleToTop())
  }

  return (
    <div>
      {statusDvf === Status.ShowParcelleResults &&
        parcelles.map(
          ({ parcelleCentre, parcelleGeography, parcelleUid }, ix) => {
            const centerMarker = {
              lat: parcelleCentre.latitude,
              lng: parcelleCentre.longitude,
            }
            const coordGlobal = geoJsonObjectToCoordinates(
              parcelleGeography
            ).map((coord) => ({
              lat: coord[1],
              lng: coord[0],
            }))
            return (
              <PolygonMarker
                key={parcelleUid}
                center={centerMarker}
                coordGlobal={coordGlobal}
                isSelected={ix === selectedParcelleIndex}
                onClick={() => selectParcelle(parcelleUid)}
              />
            )
          }
        )}
    </div>
  )
}

export default ResultsDVF
